// ---------------------------------------------------------------------------
// Shared try/catch wrapper around localStorage, used by every small
// per-browser preference (theme.ts, language.ts, mapLegend.ts) — private
// mode, a full quota, or localStorage simply not existing must never crash
// the app, just fail to persist that one preference.
// ---------------------------------------------------------------------------

export function readLocalStorage(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeLocalStorage(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    // localStorage unavailable (private mode, quota...): doesn't persist, but the app keeps working.
  }
}
